import { createSlice } from '@reduxjs/toolkit'

const stateSlice = createSlice({
    name: 'clientTrash/state',
    initialState: {
        deleteConfirmation: false,
        recoverConfirmation: false,
        selectedClient: [],
        sortedColumn: () => {},
    },
    reducers: {
        toggleDeleteConfirmation: (state, action) => {
            state.deleteConfirmation = action.payload
        },
        toggleRecoverConfirmation: (state, action) => {
            state.recoverConfirmation = action.payload
        },
        setSortedColumn: (state, action) => {
            state.sortedColumn = action.payload
        },
        setSelectedClient: (state, action) => {
            state.selectedClient = action.payload
        },
    },
})

export const { 
    toggleDeleteConfirmation,
    toggleRecoverConfirmation,
    setSortedColumn,
    setSelectedClient
} = stateSlice.actions

export default stateSlice.reducer
